import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "py-2" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "py-2" }
const _hoisted_5 = { class: "flex justify-between items-center mb-2" }
const _hoisted_6 = { class: "m-0" }
const _hoisted_7 = {
  key: 0,
  class: "svg-inline--fa fa-plus fa-w-14 text-white",
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "plus",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "svg-inline--fa fa-check fa-w-14 text-white",
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "check",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M438.6 132.5l-238 238.1c-9.3 9.3-24.4 9.3-33.7 0l-120-120c-9.3-9.3-9.3-24.4 0-33.7l28.6-28.6c9.3-9.3 24.4-9.3 33.7 0l84.3 84.3 204.6-204.6c9.3-9.3 24.4-9.3 33.7 0l28.6 28.6c9.2 9.3 9.2 24.4 0 33.7z"
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "flex gap-2" }
const _hoisted_14 = { class: "py-2" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "py-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("input", {
  name: "date_for_check",
  type: "date",
  class: "w-full rounded-md"
}, null, -1)
const _hoisted_18 = { class: "py-2" }
const _hoisted_19 = { class: "py-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("textarea", {
  class: "w-full h-20 rounded-md",
  name: "remark"
}, null, -1)

import { useStore } from 'vuex';
import ToolsUpload from '../../tools/Upload.vue'
import InputDecimal from '../../tools/InputDecimal.vue'
import ExampleTicketToolTip from './tooltip/ExampleTicketTooltip.vue'
import { getCommissionIssue } from '@/utils/ticket-config'
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckCommissionAffiliate',
  props: {
  username: String
},
  setup(__props) {

const currentBankAccountName = ref('');
const currentBankAccountNo = ref('');
const currentBankName = ref('');
const currentUsername = ref('');
const currentMobile = ref('');

const address = ref('');
const iconState = ref('plus');
const clicked = ref(false);
const store = useStore();

const typeList = ref([
  {
    value: 0,
    name: "-- Select Type --",
  },
]);

const type = ref({
  name: typeList.value[0].name,
  value: 0,
});


const getExampleImage = () =>{
  const baseUrl = window.location.origin
  return `${baseUrl}/ticket-example/รูปตัวอย่าง เช็คยอดคอมิชขั่นหรือค่าพันธม.png`
}

const convertAddress = () => {
  const lines = address.value.trim().split('\n');
  let bankName = '';
  let accountNo = '';
  let accountName = '';
  let username = '';
  let mobile = '';

  let i = 0;
  lines.forEach(line => {
    const trimmedLine = line.trim();
    if (trimmedLine) {
      if(i==0){
        accountName = trimmedLine;
      }else if (trimmedLine.startsWith('Bank:')) {
        bankName = trimmedLine.split('Bank:')[1].trim();
      } else if (trimmedLine.startsWith('Account Number:')) {
        accountNo = trimmedLine.split('Account Number:')[1].trim();
      }else if (trimmedLine.startsWith('Mobile:')) {
        mobile = trimmedLine.split('Mobile:')[1].trim();
      }else if (trimmedLine.startsWith('Username :')) {
        username = trimmedLine.split('Username :')[1].trim();
      }
    }
    i++;
  });

  currentBankName.value = bankName;
  currentBankAccountName.value = accountName;
  currentBankAccountNo.value = accountNo;
  currentUsername.value = username;
  currentMobile.value = mobile;
  if (currentBankName.value && currentBankAccountName.value && currentBankAccountNo.value  && currentUsername.value  && currentMobile.value) {
    toggleIcon()
  }
};

const toggleIcon = () => {
  iconState.value = iconState.value === 'plus' ? 'check' : 'plus';
  clicked.value = true;
};

const getType = () => {
 
 typeList.value = getCommissionIssue().map((item: any) => ({
      name: item.label,
      value: item.value
    }))
};

onMounted(() => {
  getType();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.operatorName')) + " ", 1),
        _createVNode(ExampleTicketToolTip, {
          image: getExampleImage()
        }, null, 8, ["image"]),
        _withDirectives(_createElementVNode("input", {
          name: "bank_account_name",
          type: "text",
          class: "w-full rounded-md hidden",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentBankAccountName).value = $event))
        }, null, 512), [
          [_vModelText, currentBankAccountName.value]
        ]),
        _withDirectives(_createElementVNode("input", {
          name: "bank_account_no",
          type: "text",
          class: "w-full rounded-md hidden",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentBankAccountNo).value = $event))
        }, null, 512), [
          [_vModelText, currentBankAccountNo.value]
        ]),
        _withDirectives(_createElementVNode("input", {
          name: "bank_name",
          type: "text",
          class: "w-full rounded-md hidden",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentBankName).value = $event))
        }, null, 512), [
          [_vModelText, currentBankName.value]
        ]),
        _withDirectives(_createElementVNode("input", {
          name: "username",
          type: "text",
          class: "w-full rounded-md hidden",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentUsername).value = $event))
        }, null, 512), [
          [_vModelText, currentUsername.value]
        ]),
        _withDirectives(_createElementVNode("input", {
          name: "mobile",
          type: "text",
          class: "w-full rounded-md hidden",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((currentMobile).value = $event))
        }, null, 512), [
          [_vModelText, currentMobile.value]
        ])
      ]),
      _createElementVNode("input", {
        value: _unref(store).state.selectedOperator.name,
        name: "operator_name",
        type: "text",
        class: "w-full rounded-md",
        disabled: true
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.currentAddress')), 1),
        _createElementVNode("button", {
          type: "button",
          onClick: convertAddress,
          class: _normalizeClass(['w-5 h-5 inline-flex items-center justify-center rounded-md border border-transparent shadow-sm px-4 py-3 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:col-start-2 sm:text-sm', { 'bg-green-500': clicked.value, 'bg-blue-500': !clicked.value }])
        }, [
          (iconState.value === 'plus')
            ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9))
            : (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_12))
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _withDirectives(_createElementVNode("textarea", {
          type: "text",
          class: "w-full rounded-md",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((address).value = $event)),
          rows: "7"
        }, null, 512), [
          [_vModelText, address.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.issueType')) + " ", 1),
      _withDirectives(_createElementVNode("select", {
        id: "issue_type",
        name: "issue_type",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((type.value.name) = $event)),
        class: "capitalize mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.value, (row) => {
          return (_openBlock(), _createElementBlock("option", {
            key: row.name,
            value: row.name
          }, _toDisplayString(row.name), 9, _hoisted_15))
        }), 128))
      ], 512), [
        [_vModelSelect, type.value.name]
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.dateForCheck')) + " ", 1),
      _hoisted_17
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.amountToCheck')) + " ", 1),
      _createVNode(InputDecimal, { name: "amount" })
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.remark')) + " ", 1),
      _hoisted_20
    ]),
    _createVNode(ToolsUpload)
  ], 64))
}
}

})